import {
  takeLatest, put, select, all, call,
} from 'redux-saga/effects';
import { message } from 'antd';
import { fetchDashboard } from '@api/dashboards';
import { autoRequest } from '@api/createRequestStore';

import { CLOSE_ALL_TABS } from '@store/common/types';
import * as actions from './actions';
import * as types from './types';
import { dashboardResponseSelector } from './selectors';
import { filterAndApplyState } from '../base/actions';

function* afterRequest() {
  const dashboard = yield select(dashboardResponseSelector);

  if (!dashboard) {
    return;
  }
  const { config } = dashboard;
  try {
    const {
      nocStore,
    } = config;


    let data = null;
    if (nocStore) {
      data = nocStore;
    } else if (config.base) {
      data = config.base;
    }

    yield all([
      put(filterAndApplyState(data)),
    ]);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* fetching({ id }) {
  yield actions.fetching();
  try {
    yield autoRequest(fetchDashboard, types.SCOPE, id, afterRequest);
  } catch (error) {
    yield call(message.error, error.message || 'Unknown error.');
    throw error;
  }
}

function* watchInitRequest() {
  yield takeLatest([types.INIT, CLOSE_ALL_TABS], initRequest);
}

function* watchFetching() {
  yield takeLatest([types.GET_DASHBOARD], fetching);
}

export default [watchInitRequest, watchFetching];
